import Section from 'components/atoms/Section';
import PageContainer from 'components/molecules/PageContainer';
import TermsContent from 'components/organisms/TermsContent';

const Terms = () => (
  <PageContainer
    title="Termos de uso - Luna"
    metaDescription="Os termos da Luna estão aqui para te ajudar no uso do nosso serviço. Tivemos a preocupação de deixá-lo simples e transparente."
  >
    <Section>
      <TermsContent />
    </Section>
  </PageContainer>
);

export default Terms;
